import dayjsImport from "./auth-service-tools36.js";

function isAfterMinDate(date, minDate) {
  return minDate instanceof Date ? dayjsImport(date).isAfter(dayjsImport(minDate).subtract(1, "day"), "day") : true;
}

export { isAfterMinDate };